import {
  TOGGLE_MODAL_VIP_APPLY,
} from '../actions/vipApplyModalActions';

const initialState = {
  isOpen: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TOGGLE_MODAL_VIP_APPLY:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    default:
      return state;
  }
}
